module.exports = __webpack_public_path__ + "images/wave/feedbacks/olgab.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/wave/feedbacks/olgab.jpg
// module id = 7taa
// module chunks = 4